import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/sprites/common-sprite.svg'


const _hoisted_1 = _imports_0 + '#app-logo-text'
const _hoisted_2 = _imports_0 + '#app-logo-image'
const _hoisted_3 = { class: "main" }
const _hoisted_4 = { class: "nav" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "icon" }
const _hoisted_7 = ["xlink:href"]
const _hoisted_8 = { class: "icon" }
const _hoisted_9 = ["xlink:href"]
const _hoisted_10 = {
  key: 2,
  class: "sub-container"
}
const _hoisted_11 = { class: "nav" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "icon" }
const _hoisted_14 = ["xlink:href"]
const _hoisted_15 = { class: "icon" }
const _hoisted_16 = ["xlink:href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sidebar", { min: _ctx.sub }])
  }, [
    _createElementVNode("div", _hoisted_3, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "logo" }, [
        _createElementVNode("svg", { class: "app-logo-text" }, [
          _createElementVNode("use", { "xlink:href": _hoisted_1 })
        ]),
        _createElementVNode("svg", { class: "app-logo-image" }, [
          _createElementVNode("use", { "xlink:href": _hoisted_2 })
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nav, (route, routeIndex) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: routeIndex }, [
            (route?.visible !== false)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.isExternal(route.path))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: route.path,
                        target: "_blank",
                        rel: "noopener",
                        class: _normalizeClass(route.class)
                      }, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_6, [
                          _createElementVNode("use", {
                            "xlink:href": require('@/assets/images/sprites/common-sprite.svg') + route.icon
                          }, null, 8, _hoisted_7)
                        ])),
                        _createElementVNode("span", null, _toDisplayString(route.name), 1)
                      ], 10, _hoisted_5))
                    : (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        to: route.path,
                        class: _normalizeClass([route.class, { active: _ctx.$route.matched[0].path == route.path }])
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock("svg", _hoisted_8, [
                            _createElementVNode("use", {
                              "xlink:href": require('@/assets/images/sprites/common-sprite.svg') + route.icon
                            }, null, 8, _hoisted_9)
                          ])),
                          _createElementVNode("span", null, _toDisplayString(route.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to", "class"])),
                  (route.sub)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["sub", { active: _ctx.$route.matched[0].path == route.path }])
                        }, [
                          _createElementVNode("div", _hoisted_11, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(route.sub, (sub, subIndex) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: subIndex }, [
                                (_ctx.isExternal(sub.path))
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      href: route.path,
                                      target: "_blank",
                                      rel: "noopener",
                                      class: _normalizeClass(sub.class)
                                    }, [
                                      (_openBlock(), _createElementBlock("svg", _hoisted_13, [
                                        _createElementVNode("use", {
                                          "xlink:href": require('@/assets/images/sprites/common-sprite.svg') + sub.icon
                                        }, null, 8, _hoisted_14)
                                      ])),
                                      _createElementVNode("span", null, _toDisplayString(sub.name), 1)
                                    ], 10, _hoisted_12))
                                  : (_openBlock(), _createBlock(_component_router_link, {
                                      key: 1,
                                      to: sub.path,
                                      class: _normalizeClass([sub.class, { active: _ctx.$route.path == sub.path }])
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(), _createElementBlock("svg", _hoisted_15, [
                                          _createElementVNode("use", {
                                            "xlink:href": require('@/assets/images/sprites/common-sprite.svg') + sub.icon
                                          }, null, 8, _hoisted_16)
                                        ])),
                                        _createElementVNode("span", null, _toDisplayString(sub.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to", "class"]))
                              ], 64))
                            }), 128))
                          ])
                        ], 2)
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ])
    ])
  ], 2))
}